<script>
import Multiselect from "vue-multiselect"
import DatatablePaginationTotais from "./datatable-pagination-totais.vue"

export default {
  components: {
    Multiselect,
    DatatablePaginationTotais,
  },
  props:
  {
    items: Array,
    filterOn: Array,
    fields: Array,
    jaBuscou: Boolean,
  },
  data() {
    return {
      filter: null,
      row: 0,
      currentPage: 1,
      totalRows: 0,
      perPage: 10,
      pageOptions: [5, 10, 25, 50, 100],
      sortDesc: false,
      camposSelecionados: [],
      campos: [],
    }
  },
  mounted() {
    this.totalRows = this.items.length
  },
  computed: {
    rows() {
      return this.items.length
    },
    sortBy() {
      // if (this.fields.length > 0) return this.fields[0].key
      // else return null
      return this.fields[0].key
    },
    camposDisponiveis() {
      let c = []
      this.fields.map((f) => {
        c.push(f.label)
      })
      return c
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    atualizarCampos() {
      this.campos = []
      this.camposSelecionados.map((c) => {
        let i = this.fields.findIndex(f => f.label === c)
        this.campos.push(this.fields[i])
      })
    },
    linhaSelecionada(linha) {
      this.$emit('linhaSelecionada', linha)
    }
  }
}
</script>
<template>
  <div class="row" v-if="items.length > 0">
    <div class="col-12">
      <!-- <div class="card">
        <div class="card-body"> -->
          <div class="row mt-4">
            <div class="col-sm-12 col-md-12">
              <!-- <label class="mt-3">Selecionar Campos</label> -->
              <multiselect v-model="camposSelecionados" :options="camposDisponiveis" :multiple="true"
                placeholder="Selecione os campos da tabela" @input="atualizarCampos"></multiselect>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-sm-12 col-md-4">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  Mostrar &nbsp;
                  <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                    :options="pageOptions"></b-form-select>&nbsp; registros
                </label>
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-4">
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label class="d-inline-flex align-items-center">
                  Filtrar resultado:
                  <b-form-input debounce="1000" v-model="filter" type="search" placeholder="Filtrar..."
                    class="form-control form-control-sm ms-2"></b-form-input>
                </label>
              </div>
            </div>
            <div class="col-sm-12 col-md-4">
              <download-excel class="btn btn-default" :data="items" :worksheet="'Registros'" :name="'registros.xls'">
                <button type="button" class="btn btn-primary">
                  <i class="bx bx-download font-size-16 align-middle me-2"></i>
                  Exportar para Excel
                </button>
              </download-excel>
            </div>
          </div>
          <div class="table-responsive mb-0">
            <b-table class="datatables row-pointer-thead row-pointer-tbody table-fixed table-th-fixed"
              @row-clicked="linhaSelecionada" :items="items" :fields="(campos.length > 0 ? campos : fields)"
              responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered"
              sticky-header="600px" hover></b-table>
          </div>
          <div class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <DatatablePaginationTotais :rows="rows" :totalRows="totalRows" :currentPage="currentPage"
                    :perPage="perPage"></DatatablePaginationTotais>
                  <b-pagination v-model="currentPage" :total-rows="(rows > totalRows ? totalRows : rows)"
                    :per-page="perPage"></b-pagination>
                </ul>
              </div>
            </div>
          <!-- </div>
        </div> -->
      </div>
    </div>
  </div>
  <div v-else-if="jaBuscou" class="row">
    <div class="col-12">
      <div role="danger" aria-live="polite" aria-atomic="true" class="alert alert-warning">
        Nenhum registro encontrado.
      </div>
    </div>
  </div>
  <div class="row" style="filter:alpha(opacity=50); opacity:0.0;" v-else>
    <div class="col-12">
      <div class="card">
        <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
      </div>
    </div>
  </div>
</template>
<style lang="css" scoped>
.row-pointer-tbody>>>tbody tr :hover {
  cursor: pointer
}

.row-pointer-thead>>>thead th :hover {
  cursor: pointer
}

.table-fixed>>>thead {
  text-align: left;
  position: relative;
}

.table-th-fixed>>>thead th {
  background: white;
  position: sticky;
  top: 0;
}
</style>